<sb-dialog-header>
  <h1 sb-dialog-title>
    {{ 'Add new hire' | translate }}
  </h1>
</sb-dialog-header>

<sb-hire-form
  [form]="form"
  [hasContractTemplates]="hasContractTemplates"
  [showGuardianSignature]="guardianSignatureEnabled"
  [showGuardianCount]="guardianCountEnabled"
  [showGermanFields]="isGermanHire()"
  [showPayrollNotice]="showPayrollNotice()"
  [teams]="teams()"
  [languages]="languages"
  [employmentCategoryItems]="employmentCategories()"
  (submitted)="submit()"
/>

<sb-dialog-footer>
  <sb-dialog-footer-actions [align]="'end'">
    <button sb-button [color]="'primary'" [sbLadda]="loading()" (click)="submit()">
      {{ 'Send Invite' | translate }}
    </button>
  </sb-dialog-footer-actions>
</sb-dialog-footer>
